import React, { useState } from 'react';
import { bool } from 'prop-types';
import Button from '../../components/Button';
import Footer from '../../components/Footer';
import Page from '../../components/Page';
import Title from '../../components/Title';
import Typography from '../../components/Typography';
import piwik from '../../services/analytics';
import { usePageView } from '../../hooks/analytics';
import { WELCOME, eventTags } from '../../services/analytics/tags';
import useConnect from './hooks';
import messages from './messages';
import useStyles from './styles';

const Welcome = ({ asLandingPage }) => {
  const [isTC, toogleIsTC] = useState(false);
  const classes = useStyles();
  usePageView(WELCOME);
  const {
    next,
    settings: { EMERGENCY_PHONE_NUMBER, TERMS_AGREEMENT },
    userDataEligibilityPdf,
    isMultiChannelMode,
  } = useConnect();

  if (asLandingPage) return <div name="landing" />;
  return (
    <Page name="welcome" direction="column">
      <div className={classes.content}>
        <Title content={messages.title} src="welcome" />
        <Typography content={messages.description} />
      </div>

      <Footer
        checkbox={
          TERMS_AGREEMENT &&
          (() => {
            piwik.trackEvent(eventTags.welcome_check_conditions);
            return toogleIsTC(!isTC);
          })
        }
        emergency={!isMultiChannelMode && EMERGENCY_PHONE_NUMBER}
        privacyPolicy={userDataEligibilityPdf && isMultiChannelMode}
      >
        <Button
          name="register"
          content={messages.button}
          disabled={TERMS_AGREEMENT ? !isTC : false}
          onClick={() => {
            piwik.trackEvent(eventTags.welcome_accept_conditions);
            next();
          }}
        />
      </Footer>
    </Page>
  );
};

Welcome.propTypes = {
  asLandingPage: bool,
};

export default Welcome;
